// extracted by mini-css-extract-plugin
export default {"page":"ContactUsPage_page__e1Y2X","root":"ContactUsPage_root__BYBmd","title":"ContactUsPage_title__t1SEX","content":"ContactUsPage_content__18Ib6"};